import React, { useEffect, useState } from "react";
import { FieldType, Unit } from "../../../services/helpers/types";
import SelectField from "../../molecules/SelectField/SelectField";
import NumberField from "../NumberField/NumberField";
import { Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getAddNumberUnitField } from "./helpers";

interface AddNumberNumberFieldProps {
  field?: FieldType;
  onFieldChange: (name: string, value?: string) => void;
  hideDefaults?: boolean;
}

const AddNumberNumberField = (props: AddNumberNumberFieldProps) => {
  const { field, onFieldChange, hideDefaults } = props;

  const { t } = useTranslation();

  const [defaultValue1, setDefaultValue1] = React.useState<string>("");
  const [defaultValue2, setDefaultValue2] = React.useState<string>("");
  const [unit1, setUnit1] = useState<Unit | undefined>(undefined);
  const [unit2, setUnit2] = useState<Unit | undefined>(undefined);

  useEffect(() => {
    const [defaultValue1, defaultValue2] =
      field?.defaultValue?.split(";") ?? [];
    setDefaultValue1(defaultValue1 ?? "");
    setDefaultValue2(defaultValue2 ?? "");
    const [unit1, unit2] = field?.unit?.split(",") ?? [];
    setUnit1(unit1 as Unit);
    setUnit2(unit2 as Unit);
  }, [field]);

  const handleSelectUnit1 = (value: string) => {
    setUnit1(value as Unit);
    onFieldChange("unit", `${value},${unit2}`);
  };

  const handleSelectUnit2 = (value: string) => {
    setUnit2(value as Unit);
    onFieldChange("unit", `${unit1},${value}`);
  };

  const handleDefaultValueChange1 = (value?: string) => {
    setDefaultValue1(value ?? "");
    onFieldChange("defaultValue", `${value ?? ""};${defaultValue2}`);
  };

  const handleDefaultValueChange2 = (value?: string) => {
    setDefaultValue2(value ?? "");
    onFieldChange("defaultValue", `${defaultValue1};${value ?? ""}`);
  };

  if (hideDefaults) {
    return null;
  }

  return (
    <>
      <Divider className="dui-divider" />

      <div className="dui-example-field-multi">
        <div className="dui-example-field">
          <div className="dui-example-field-title">
            {t("firstDefaultValue")}:
          </div>
          <NumberField
            field={field}
            value={defaultValue1}
            customUnit={unit1}
            onChange={handleDefaultValueChange1}
            placeholder={t("defaultValuePlaceholder")}
          />
        </div>
        <div className="dui-example-field">
          <div className="dui-example-field-title">{t("firstUnit")}:</div>
          <SelectField
            value={unit1}
            onChange={handleSelectUnit1}
            field={getAddNumberUnitField(t)}
          />
        </div>
      </div>
      <Divider className="dui-divider" />
      <div className="dui-example-field-multi">
        <div className="dui-example-field">
          <div className="dui-example-field-title">
            {t("secondDefaultValue")}:
          </div>
          <NumberField
            field={field}
            value={defaultValue2}
            customUnit={unit2}
            onChange={handleDefaultValueChange2}
            placeholder={t("defaultValuePlaceholder")}
          />
        </div>

        <div className="dui-example-field">
          <div className="dui-example-field-title">{t("secondUnit")}:</div>
          <SelectField
            value={unit2}
            onChange={handleSelectUnit2}
            field={getAddNumberUnitField(t)}
          />
        </div>
      </div>
      <Divider className="dui-divider" />
    </>
  );
};

export default AddNumberNumberField;
